module.exports = __webpack_public_path__ + "856b09c2f984c2a98354a11cbe496ac1.MP3";